import { handleActions } from 'redux-actions';
import * as actions from '../actions/adminActions';
import { cities, properties, roles } from '../../constants';
import * as R from 'ramda';

const defaultState = {
  groups: [],
  groupOptions: [],
  currentGroupId: null,
  currentGroup: null,
  users: [],
  userMap: {},
  userOptions: [],
  roleOptions: [...roles],
  sites: [],
  sitesOptions: [],
  cultureMapSites: [],
  cultureMapSitesOptions: [],
  cultureMapSitesOptionsBasic: [],
  currentSiteId: null,
  currentSite: null,
  propertiesOptions: [...properties],
  citiesOptions: [...cities],
  currentUser: null,
  currentUserId: null,
  emailTemplates: [],
  currentEmailTemplate: null,
};

const toOptionItem = record => ({
  key: record.id,
  text: record.name,
  value: record.id,
});

const toProperty = site => {
  const order = {
    CultureMap: 0,
    AutomotiveMap: 1,
    InnovationMap: 2,
    SportsMap: 3,
  };

  return {
    id: site.id,
    order: order[site.property],
    text: order[site.property] === 0 ? `${site.city}` : `${site.property}`,
    value: site.id,
  };
};

const mapRecordsToOptions = records => {
  return records.map(toOptionItem);
};

const reducer = handleActions(
  {
    [actions.getUsersSuccess]: (state, { payload: { users } }) => {
      const user = state.currentUserId ? users.find(user => user.id === state.currentUserId) : null;
      return {
        ...state,
        users,
        currentUser: user,
        userOptions: mapRecordsToOptions(users),
        userMap: R.indexBy(R.prop('id'), users),
      };
    },
    [actions.setGroupSuccess]: (state, { payload: { groupId } }) => {
      const group = state.groups.find(group => group.id === groupId);
      return { ...state, currentGroup: group, currentGroupId: groupId };
    },
    [actions.setUserSuccess]: (state, { payload: { userId } }) => {
      const user = state.users.find(user => user.id === userId);
      return { ...state, currentUser: user, currentUserId: userId };
    },
    [actions.getAllTemplatesSuccess]: (state, { payload: { templates } }) => {
      return { ...state, emailTemplates: templates };
    },
    [actions.getTemplateByIdSuccess]: (state, { payload: { template } }) => {
      return { ...state, currentEmailTemplate: template };
    },
    [actions.getSitesSuccess]: (state, { payload: { sites } }) => {
      if (!sites) return { ...state };
      const currentSite = state.currentSiteId ? sites.find(site => site.id === state.currentSiteId) : null;
      const cultureMapSites = sites.filter(site => site.property === 'CultureMap');
      return {
        ...state,
        sites,
        cultureMapSites,
        currentSite,
        sitesOptions: [{ id: '', name: '' }, ...sites].map(site => {
          return {
            key: site.id,
            text: site.name,
            value: site.id,
          };
        }),
        cultureMapSitesOptions: [{ id: '', name: '' }, ...cultureMapSites].map(site => {
          return {
            key: site.id,
            text: site.name,
            value: site.id,
          };
        }),
        cultureMapSitesOptionsBasic: [{ id: '', name: '' }, ...cultureMapSites].map(site => {
          return {
            key: site.name,
            text: site.name,
            value: site.name,
          };
        }),
        sitesOptionsDetail: [{ id: '', property: '' }, ...sites].map(toProperty).map(site => {
          return {
            key: site.id,
            text: site.text,
            value: site.id,
          };
        }),
        cultureMapSitesOptionsDetail: [{ id: '', property: '' }, ...cultureMapSites].map(toProperty).map(site => {
          return {
            key: site.id,
            text: site.text,
            value: site.id,
          };
        }),
      };
    },
    [actions.setSiteSuccess]: (state, { payload: { siteId } }) => {
      const currentSite = state.sites.find(site => site.id === siteId);
      return { ...state, currentSiteId: siteId, currentSite };
    },
    [actions.getGroupsSuccess]: (state, { payload: { groups } }) => {
      if (!groups) return { ...state };
      const currentGroup = state.currentGroupId ? groups.find(group => group.id === state.currentGroupId) : null;
      const groupOptions = mapRecordsToOptions(groups);
      // make culturemap group the first one
      const cultureMapGroup = groups.find(group => group.name === 'CultureMap');
      if (cultureMapGroup) {
        groupOptions.unshift(
          groupOptions.splice(
            groupOptions.findIndex(group => group.key === cultureMapGroup.id),
            1
          )[0]
        );
      }
      return { ...state, groups, groupOptions, currentGroup };
    },
  },
  defaultState
);

export default reducer;
